document.addEventListener('DOMContentLoaded', () => {
  
//   Mobile Nav
    const mobileBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  mobileBtn.addEventListener('click', () => {
    if (mobileMenu.classList.contains('max-h-0')) {
      mobileMenu.classList.remove('max-h-0');
      mobileMenu.classList.add('max-h-[500px]'); // adjust depending on menu size
    } else {
      mobileMenu.classList.add('max-h-0');
      mobileMenu.classList.remove('max-h-[500px]');
    }
  });



});

    
//Sticky header
document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("site-header");
  const body = document.body;

  const headerHeight = header.offsetHeight;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 90) {
      // Sticky state
      header.classList.add("fixed");
      body.style.paddingTop = `${headerHeight}px`;

    } else {
      // Return to normal flow
      header.classList.remove("fixed");
      body.style.paddingTop = "0px";
    }
  });
});

  
  